module.exports = __webpack_public_path__ + "img/bb9a2e807ffd40c4988c8e2bb195924d-640.5dcad476.jpg";